import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';

import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { UserPasswordResetRequestModel } from '../models/user-password-reset-request.model';
import { submitUserPasswordResetRequest } from '../state/user-password-reset-request.actions';
import { getUserPasswordResetRequestCallState } from '../state/user-password-reset-request.selectors';

@Component({
    selector: 'ndt-user-password-reset-request',
    templateUrl: './user-password-reset-request.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UserPasswordResetRequestComponent implements OnInit {
   callState: Observable<CallState>;

   constructor(private fb: UntypedFormBuilder, private store: Store, private dialogService: LcsDialogService) {}

   ngOnInit() {
      this.callState = this.store.pipe(select(getUserPasswordResetRequestCallState));
   }

   onCloseClick() {
      this.dialogService.close();
   }

   onUserPasswordResetRequest(userPasswordResetRequest: UserPasswordResetRequestModel): void {
      this.store.dispatch(submitUserPasswordResetRequest({ userPasswordResetRequest }));
   }
}
